import { updateTrajectoryStages, } from '@/entities/engagement';
export async function updateTrajectoryStagesAction(trajectoryCode, stages) {
    await updateTrajectoryStages(trajectoryCode, stages);
}
